import makeStyles from '@mui/styles/makeStyles'
import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type Props = {
  iconFilter: SxProps
  filtersMenu: SxProps
  selectType: SxProps
  option: SxProps
  input: SxProps
  wrapperActions: SxProps
}

export const useStyles = makeStyles(() => ({
  popper: {
    boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',
    borderRadius: '4px',
    maxWidth: 'min-content',
    padding: '4px',

    '& .MuiList-root': {
      padding: 0
    }
  }
}))

export const filterColumnHeaderStyles: Props = {
  iconFilter: {
    fontSize: '22px'
  },

  filtersMenu: {
    '& .MuiPaper-root': {
      width: '240px',
      padding: theme.spacing(0.5),
      borderRadius: '4px',
      marginTop: '8px',
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',

      '& .MuiList-root': {
        padding: 0
      }
    }
  },

  selectType: {
    width: '100%',
    padding: 0,

    '& .MuiSelect-select': {
      height: '20px !important',
      paddingRight: '44px !important'
    }
  },

  option: {
    whiteSpace: 'normal',
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    minHeight: '38px !important',
    padding: '4px 8px'
  },

  input: {
    width: '100%',
    margin: '4px 0 8px 0'
  },

  wrapperActions: {
    width: '100%',

    '& .MuiButton-root': {
      flex: '1 1 auto',
      height: '30px',
      fontSize: '14px',
      lineHeight: '18px',
      padding: '6px',
      margin: 0,

      '&:first-child': {
        marginRight: '4px'
      }
    }
  }
}
